/**
 * Implementation of Billing page
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import { Else, If, Then } from "react-if";
import { useGetCurrentUser } from "../../../api/reactQuery";
import { PlanName } from "../../../api/responses";
import LTDPricingCard from "../../../components/Billing/LTDPricingCard";
import { BsPatchCheckFill } from "react-icons/bs";
import PricingCard from "../../../components/Billing/PricingCard";
import { PaddleProduct } from "../../../globals/contants";

export default function Billing() {
  const { data: currentUser, isLoading } = useGetCurrentUser(true);

  if (isLoading) return <p>Loading...</p>;

  return (
    <If condition={currentUser?.planName === PlanName.LTD}>
      <Then>
        <div className="mb-5 max-w-md">
          <div className="bg-white rounded-xl shadow p-5 overflow-hidden relative">
            <div className="absolute transform -rotate-45 left-0 right-32 -translate-x-28 py-1 text-center bg-accent text-white text-sm">
              Lifetime Validity&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div className="flex justify-center py- text-5xl text-accent">
              <BsPatchCheckFill />
            </div>

            <div>
              <p className="text-center text-lg mt-2">Current Plan: LTD</p>
              <p className="text-center text-gray-500">
                Purchased on{" "}
                {new Date(currentUser?.purchasedOn || "").toDateString()}
              </p>
            </div>

            <div className="p-4 pt-8">
              <p className="text-lg text-gray-500">
                Enjoy following benefits for Lifetime
              </p>
              <ul className='list-["✅"]'>
                <li className="text-lg my-1">
                  &nbsp;Monitor <b>unlimited domains</b>.
                </li>
                <li className="text-lg my-1">
                  &nbsp;Get <b>unlimited alerts</b>.
                </li>
                <li className="text-lg my-1">
                  &nbsp;Add <b>multiple E-mails</b> to get alerts.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Then>
      <Else>
        <div className="flex flex-wrap">
          <div className="w-full items-start flex lg:w-1/2 justify-center lg:justify-end p-4">
            <PricingCard
              planName="Starter"
              planId={PaddleProduct.SUBSCRIPTION_LIMITED}
              price="$17"
              features={
                <ul className='list-["✅"]'>
                  <li className="text-lg my-1">
                    &nbsp;Monitor upto <b>50 domains</b>.
                  </li>
                  <li className="text-lg my-1">
                    &nbsp;Get <b>unlimited E-mail alerts</b>.
                  </li>
                  <li className="text-lg my-1">
                    &nbsp;Get alerts for <b>SSL renewals</b>.
                  </li>
                  <li className="text-lg my-1">
                    &nbsp;Add upto <b>2 extra E-mails</b> to get alerts.
                  </li>
                </ul>
              }
            />
          </div>
          <div className="w-full items-start flex lg:w-1/2 justify-center lg:justify-start p-4">
            <PricingCard
              planName="Agency"
              planId={PaddleProduct.SUBSCRIPTION_UNLIMITED}
              price="$48"
              highligted
              features={
                <>
                  <ul className='list-["✅"]'>
                    <li className="text-lg my-1">
                      &nbsp;Monitor <b>unlimited domains</b>.
                    </li>
                    <li className="text-lg my-1">
                      &nbsp;Get <b>unlimited E-mail alerts</b>.
                    </li>
                    <li className="text-lg my-1">
                      &nbsp;Get alerts for <b>SSL renewals</b>.
                    </li>
                    <li className="text-lg my-1">
                      &nbsp;Add upto <b>10 extra E-mails</b> to get alerts.
                    </li>
                  </ul>
                  <div className="h-0 bg-gray-100 my-2"></div>
                  <span className="rounded-full bg-gray-100 text-sm px-2">
                    Coming Soon
                  </span>
                  <ul className="list-['⏳']">
                    <li className="text-lg my-1">
                      &nbsp;Get alerts on Phone, SMS, Slack or Teams
                    </li>
                    <li className="text-lg my-1">&nbsp;Webhooks Integration</li>
                  </ul>
                </>
              }
            />
          </div>
        </div>
      </Else>
    </If>
  );
}
